var codeblock_default = {
  "blockStyleSpacing": "FfytB",
  "codeBlock": "yD43b FfytB",
  "renderedInTable": "IqdxP"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
